module.exports = __webpack_public_path__ + "img/logo10.affce834.png";